import axios from '../host';

const config = {
  headers: {
    'Content-Type': 'application/json',
  },
};

export const getCompetitors = (studentId) => {
  return axios.get(`/api/matching/student/${studentId}/competitors`, config);
};

export const getTeachers = (studentId) => {
  return axios.get(`/api/matching/student/${studentId}/teachers`, config);
};

export const matchingSave = (studentId, competitorId, result, isTest) => {
  return axios.post(
    `/api/matching/student/${studentId}/save-match`,
    { competitorId, result, isTest },
    config,
  );
};

export const getScore = (matchingId) => {
  return axios.get(`/api/matching/matching/${matchingId}/score`, config);
};

export const eventSave = (studentId, amount) => {
  return axios.post(
    `/api/matching/student/${studentId}/save-event`,
    { amount },
    config,
  );
};

export const getMatching = (studentId) => {
  return axios.get(`/api/matching/student/${studentId}/matching`, config);
};

export const getMatchingActive = (studentId) => {
  return axios.get(`/api/matching/student/${studentId}/matching-active`, config);
};

export const getMatchingTest = (studentId) => {
  return axios.get(`/api/matching/student/${studentId}/matching-test`, config);
};

export const getCoin = (studentId, matchingId) => {
  return axios.get(
    `/api/matching/student/${studentId}/matching/${matchingId}/get-coin`,
    config,
  );
};
